/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const PlayIcon = /*#__PURE__*/ createSvgIcon(
  'PlayIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M7 14.12V5.88c0-.226.076-.408.228-.547a.762.762 0 01.531-.208c.063 0 .13.01.2.031.069.021.136.051.201.091l6.36 4.128a.804.804 0 01.261.277.703.703 0 010 .703.748.748 0 01-.26.27l-6.361 4.13a.796.796 0 01-.41.12c-.2 0-.375-.07-.525-.208A.71.71 0 017 14.12zm1.5-1.37L12.75 10 8.5 7.25v5.5z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default PlayIcon;
